import { api } from './authenticatedApi';

export class AnalysisService {
  static async listAnalyses() {
    return api.get('/analysis');
  }

  static async startAnalysis(data: {
    repositoryId: string;
    repositoryName: string;
    platform: string;
    repositoryUrl?: string;
    cloneUrl?: string;
    socketId: string;
    refType?: 'branch' | 'tag' | 'commitSha';
    refValue?: string;
  }) {
    return api.post('/analysis/repository', data);
  }

  static async getResults(jobId: string) {
    return api.get(`/analysis/${jobId}/results`);
  }

  static async getJobStatus(jobId: string) {
    return api.get(`/analysis/jobs/${jobId}`);
  }

  static async generateRecommendations(
    jobId: string,
    context: {
      projectScale: number;
      teamSize: number;
      autonomyLevel: string;
      additionalContext?: string[];
    },
  ) {
    return api.post(`/analysis/${jobId}/recommendations`, context);
  }

  static async retryAnalysis(jobId: string, socketId?: string) {
    return api.post(`/analysis/retry/${jobId}`, { socketId });
  }

  static async scanUrl(data: {
    repositoryUrl: string;
    socketId: string;
    refType?: 'branch' | 'tag' | 'commitSha';
    refValue?: string;
  }) {
    return api.post('/analysis/scan-url', data);
  }

  static async cancelAnalysis(jobId: string) {
    return api.delete(`/analysis/jobs/${jobId}`);
  }

  static async getAnalyzedRepositories(params?: {
    page?: number;
    limit?: number;
    search?: string;
  }) {
    return api.get('/analysis/repositories', { params });
  }
}
